import "react-quill/dist/quill.snow.css";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Space,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IconUploadImage } from "@assets";
import ReactQuill from "react-quill";
import {
  CheckOutlined,
  CloseCircleFilled,
  CloseOutlined,
} from "@ant-design/icons";
import api from "../../../../api/api";
import { localStorage } from "@utils";
import { useTranslation } from "react-i18next";
import { IconLeft } from "../../../../assets/icons";
import { useNavigate } from "react-router-dom";

const RootContainer = styled.div`
  .ant-form {
    .buttons-wrapper {
      position: absolute;
      top: -64px;
      right: 12px;
    }

    .ant-btn {
      height: 48px;
      width: 172px;
    }

    .ant-btn-default {
      border: 1px solid ${(props) => props.theme.primaryColor} !important;
      background: ${(props) => props.theme.backgroundColor};

      :hover {
        background: ${(props) => props.theme.backgroundColor} !important;
      }

      .anticon {
        color: ${(props) => props.theme.primaryColor};
        font-weight: bold;
      }
    }

    .ant-btn-primary {
      :disabled {
        border: none !important;

        :hover {
          background: rgba(0, 0, 0, 0.04) !important;
          border: none !important;
        }
      }
    }
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #1d1014;
  line-height: 1;
`;

const LeftSide = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: ${(props) => props.theme.backgroundColor};

  label {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Text = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: #1d1014;
  text-align: left;
`;

const LightText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #686868;
`;

const GrayText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #b9b9b9;
  white-space: pre-wrap;
  text-align: center;
`;

const Box = styled.div`
  width: 70%;
  height: auto;
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #b9b9b9;
  cursor: pointer;
  position: relative;
  .anticon {
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 32px;
    color: #868686;
  }
`;

const SpinWrapper = styled.div`
  padding-top: 35vh;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  text-align: right;
`;


const Topbar = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: center;

  .ant-btn-default {
    height: 48px;
    padding: 0 12px !important;
    border: 1px solid #1859FF !important;
    background: #F0F6FE !important;
    color: #191114 !important;
    border-radius:8px;

  }

  .ant-btn-primary {
    width: 172px;
    height: 48px;
  }
`;

const TitleWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;


const GrayTitle = styled(Title)`
  color: #868686;
`;



const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const BusinessInformation = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [file, setFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [disabledSave, setDisabledSave] = useState(true);
  const [form] = Form.useForm();

  const {t} = useTranslation();

    const storeLang = localStorage.getStoreLang() || [];
    const langCount = storeLang?.length;

  useEffect(() => {
    getBusinessInformation();

    // eslint-disable-next-line
  }, []);

  const getBusinessInformation = () => {
    api
      .getBusinessInformation()
      .then(({ data }) => {
        setLoading(false);
        setData(data);
        setLogoUrl(data.logo);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const successCallback = (payload) => {
    setIsEdit(false);
    setLogoUrl(payload.logo);
    setFile(null);
    setData(payload);
  };

  const doPost = (payload) => {
    api
      .updateBusinessInformation(payload)
      .then(() => {
        setConfirmLoading(false);
        message.success(t('success'));
        successCallback(payload);
      })
      .catch((error) => {
        setConfirmLoading(false);
        message.error(error);
      });
  };

  const uploadImage = (payload) => {
    api
      .uploadMedia({
        file,
        file_path: file.type,
      })
      .then(({ data: { url } }) => {
        doPost({
          logo: url,
          ...payload,
        });
      })
      .catch((error) => {
        setConfirmLoading(false);
        message.error(error);
      });
  };

  // const handleFileChange = (e) => {
  //   if (e.target.files.length === 0) {
  //     return;
  //   }
  //   setFile(e.target.files[0]);
  //   setIsEdit(true);

  //   let formFields = form.getFieldsValue();
  //   setDisabledSave(!formFields.name_primary && !formFields.name_secondary);
  // };

//   const handleFileChange = (e) => {
//   if (e.target.files.length === 0) {
//     return;
//   }

//   const file = e.target.files[0];
//   const allowedTypes = ["image/png", "image/jpg", "image/jpeg"];

//   if (!allowedTypes.includes(file.type)) {
//     message.warning("Only PNG, JPG, and JPEG files are allowed.");
//     return;
//   }

//   setFile(file);
//   setIsEdit(true);

//   let formFields = form.getFieldsValue();
//   setDisabledSave(!formFields.name_primary && !formFields.name_secondary);
// };


//   const handleRemoveClicked = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setFile(null);
//     setLogoUrl(null);
//     setIsEdit(true);
//   };

const handleFileChange = (e) => {
  if (e.target.files.length === 0) return;

  const selectedFile = e.target.files[0];
  const allowedTypes = ["image/png", "image/jpg", "image/jpeg"];

  // ✅ Check file type
  if (!allowedTypes.includes(selectedFile.type)) {
    message.warning(t('slider_image_limit'));
    e.target.value = ""; // reset file input
    return;
  }

  // ✅ Check file size (2MB limit)
  const maxSize = 2 * 1024 * 1024;
  if (selectedFile.size > maxSize) {
    message.warning(t('image_less_than'));
    e.target.value = ""; // reset file input
    return;
  }

  setFile(selectedFile);
  setLogoUrl(null);
  setIsEdit(true);

  const formFields = form.getFieldsValue();
  setDisabledSave(!formFields.name_primary && !formFields.name_secondary);

  // ✅ Allow user to reselect the same file again
  e.target.value = "";
};

const handleRemoveClicked = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setFile(null);
  setLogoUrl(null);
  setIsEdit(true);
};


  const onCancel = () => {
    if (!confirmLoading) {
      setIsEdit(false);
      setLogoUrl(data.logo);
      setFile(null);
      form.resetFields();
    }
  };

  const onFieldsChange = (changedFields, allFields) => {
    setIsEdit(true);
    setDisabledSave(
      allFields
        .filter(
          (field) =>
            field.name[0] === "name_primary" ||
            field.name[0] === "name_secondary"
        )
        .find((field) => field.value === undefined || field.value === "")
    );
  };

  const onFinish = ({
    name_primary,
    name_secondary,
    description_primary,
    description_secondary,
  }) => {
    if (!confirmLoading) {
      setConfirmLoading(true);
      let payload = {
        name: { primary: name_primary, secondary: langCount === 2 ? name_secondary : null },
        description: {
          primary: description_primary,
          secondary: langCount === 2 ? description_secondary : null,
        },
      };
      if (file) {
        uploadImage(payload);
        return;
      }

      payload.logo = data.logo;
      doPost(payload);
    }
  };

  const navigate = useNavigate();

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  return (
    <RootContainer>
      <Title style={{fontSize:"28px",marginTop:"20px",marginBottom:"40px"}}>{t('store_info')}</Title>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Row gutter={[24, 24]}>
  <Col xs={24} md={6}>
              <LeftSide>
                <Text>{t('logo')}</Text>
                <label htmlFor="file-input">
                  <Box>
                    {file || logoUrl ? (
                      <Image
                        style={{ borderRadius: "7px" }}
                        src={file ? URL.createObjectURL(file) : logoUrl}
                        preview={false}
                      />
                    ) : (
                      <>
                        <IconUploadImage />
                        <GrayText>{t('upload_file_or_drag')}</GrayText>
                      </>
                    )}
                    {(file || logoUrl) && (
                      <CloseCircleFilled onClick={handleRemoveClicked} />
                    )}
                  </Box>
                </label>
                <input
                  id="file-input"
                  type="file"
                  disabled={file}
                  hidden
                  onChange={handleFileChange}
                   accept=".jpg,.jpeg,.png"
                />
                <LightText>{t('business_info_image_limit')}</LightText>
              </LeftSide>
            </Col>
            <Col xs={24} md={18}>
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  name_primary: data.name?.primary,
                  name_secondary: data.name?.secondary,
                  description_primary: data.description?.primary,
                  description_secondary: data.description?.secondary,
                }}
                onFieldsChange={onFieldsChange}
                onFinish={onFinish}
              >
                {isEdit && (
                  <Form.Item className="buttons-wrapper">
                    <ButtonWrapper>
                      <Space size={"large"}>
                        <Button
                          type="default"
                          icon={<CloseOutlined />}
                          onClick={onCancel}
                        >
                          {t('cancel')}
                        </Button>
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={(!file && !logoUrl) || disabledSave}
                          loading={confirmLoading}
                          icon={<CheckOutlined />}
                        >
                          {t('save')}
                        </Button>
                      </Space>
                    </ButtonWrapper>
                  </Form.Item>
                )}
                <Form.Item
                  name={"name_primary"}
                  label={`${t('business_name')} (${storeLang[0]?.language})`}
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <Input maxLength={100} showCount />
                </Form.Item>
                {langCount === 2 &&
                <Form.Item
                  name={"name_secondary"}
                  label={`${t('business_name')} (${storeLang[1]?.language})`}
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                >
                  <Input maxLength={100} showCount />
                </Form.Item>
                  }
                <Form.Item
                  name={"description_primary"}
                  label={`${t('about_us')} (${storeLang[0]?.language})`}
                >
                  <ReactQuill
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder={t('write_about_business')}
                  />
                </Form.Item>
                {langCount === 2 &&
                <Form.Item
                  name={"description_secondary"}
                  label={`${t('about_us')} (${storeLang[1]?.language})`}
                >
                  <ReactQuill
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder={t('write_about_business')}
                  />
                </Form.Item>
                }
              </Form>
            </Col>
          </Row>
        </>
      )}
    </RootContainer>
  );
};

export default BusinessInformation;
